import { DashboardIcon } from 'images/icons/png/v2';
import styled from 'styled-components';
import { H2 } from 'styles/Styles.styled';

const EmptyCollocationCentersList = () => {
  return (
    <EmptyBox>
      <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center' }}>
        <IconBox>
          <img src={DashboardIcon} alt="dashboard icon" />
        </IconBox>
        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center' }}>
          <H2>There are no added co-location centres yet</H2>
          <div>Once you add a co-location centre, it appears here</div>
        </div>
      </div>
    </EmptyBox>
  );
};

const EmptyBox = styled.div`
  width: 100%;
  height: 400px;
  margin: auto;
  background-color: ${(props) => props.theme.colors.primaryWhite};
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 0rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  > div {
    flex: 1;
  }
`;

const IconBox = styled.div`
  width: 158px;
  height: 158px;
  margin: auto;
  align-self: flex-start;
`;

export default EmptyCollocationCentersList;
